import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { ExtractItem } from 'src/utils/extractDescription'
import transactionLabel from 'src/utils/transactionLabel'
import { PixResponse } from './ProofResponses'

import { config } from 'src/config'
import { useAuth } from 'src/hooks/auth'
import dateToLine from 'src/utils/dateToLine'
import { documentFormatted } from 'src/utils/documentFormatted'
import toLocaleAmount from 'src/utils/toLocaleAmount'
import { Button } from '../button'
import {
  ButtonWrapper,
  CloseIcon,
  DownloadIcon,
  InfoModal,
  ModalContent,
  ModalHeader,
  Section,
  SectionCPNJ,
  SectionItem,
  SectionPayerName,
  SectionTitle,
} from '../ModalConfirmOperation/styles'

export const Pix: FC<{ data: ExtractItem; closeModal: () => void }> = ({
  data,
  closeModal,
}) => {
  const { user, account } = useAuth()

  const txType = data.type.toLowerCase()

  const naviagate = useNavigate()

  if (!txType.includes('pix')) {
    naviagate('/extract')
  }

  function printPDF() {
    if (!data) return 'null'
    const receiptString = JSON.stringify({ ...data, user })

    localStorage.setItem('temp_receipt_to_print', receiptString)

    window.open(`${config.FRONTEND_URL}/PDF`)
  }

  const response = data.response as PixResponse

  const label = transactionLabel(data)
  const beneficiaryName =
    data.direction === 'out'
      ? data?.data?.beneficiaryName
      : data?.data.user?.name || user.name || 'Desconhecido'

  const beneficiaryDocument =
    data.direction === 'out'
      ? response?.data?.counterparty?.tax_number ||
        response?.counterparty?.tax_number ||
        'Desconhecido'
      : data.direction === 'in'
      ? user.document
      : 'Desconhecido'

  const counterpartyBank =
    data.direction === 'out'
      ? response?.data?.counterparty_bank_account?.bank_number ||
        response?.counterparty_bank_account?.bank_number
      : data.direction === 'in'
      ? 'Symbank'
      : 'Desconhecido'

  const beneficiaryBank =
    data.direction === 'in'
      ? response?.data?.counterparty_bank_account?.bank_number ||
        response?.counterparty_bank_account?.bank_number ||
        data?.data?.data?.payer?.bank?.name
      : 'Symbank'

  const counterPartyName =
    data.direction === 'out'
      ? user.name
      : response?.data?.counterparty?.legal_name ||
        response?.counterparty?.legal_name ||
        data?.data?.data?.payer?.name ||
        'Desconhecido'

  const counterPartyDocument =
    data.direction === 'out'
      ? user.document
      : response?.data?.counterparty?.tax_number ||
        response?.counterparty?.tax_number ||
        data?.data?.data?.payer?.document ||
        'Desconhecido'

  const PaymentAgencyOrIdentifier =
    data.direction === 'out'
      ? `Nº IDENTIFICADOR ${account.number_identifier}`
      : data.direction === 'in'
      ? data?.data?.data?.payer?.bank?.name ||
        `AG ${
          response?.data?.counterparty_bank_account?.branch ||
          response?.counterparty_bank_account?.branch
        } | Conta ${
          response?.data?.counterparty_bank_account?.account_number ||
          response?.counterparty_bank_account?.account_number
        }  - ${
          response?.data?.counterparty_bank_account?.account_digit ||
          response?.counterparty_bank_account?.account_digit
        }`
      : 'Qualquer coisa'

  const BeneficiaryAgencyOrIdentifier =
    data.direction === 'in'
      ? `Nº IDENTIFICADOR ${account.number_identifier}`
      : data.direction === 'out'
      ? `AG ${
          response?.data?.counterparty_bank_account?.branch ||
          response?.counterparty_bank_account?.branch
        } | Conta ${
          response?.data?.counterparty_bank_account?.account_number ||
          response?.counterparty_bank_account?.account_number
        }  - ${
          response?.data?.counterparty_bank_account?.account_digit ||
          response?.counterparty_bank_account?.account_digit
        }`
      : 'Qualquer coisa'

  const city = data?.data?.receiver?.city
  const txId = data?.data?.txid

  return (
    <>
      <ModalHeader>
        <div>
          <span>{label}</span>
          <button onClick={closeModal}>
            <CloseIcon />
          </button>
        </div>
      </ModalHeader>
      <ModalContent>
        <InfoModal>
          <div>
            <p>R$ {toLocaleAmount(data?.amount)}</p>
          </div>
          <span>{dateToLine(data?.created_at)}</span>
        </InfoModal>
        <Section>
          <SectionTitle>Pagador</SectionTitle>
          <SectionPayerName>
            <span>NOME</span>
            <p>{counterPartyName}</p>
          </SectionPayerName>
          <SectionCPNJ>
            <span>Documento</span>
            <p>{documentFormatted(counterPartyDocument!)}</p>
          </SectionCPNJ>
          {beneficiaryBank && (
            <SectionItem>
              <span>INSTITUIÇÃO</span>
              <p>{beneficiaryBank}</p>
            </SectionItem>
          )}
        </Section>
        <Section>
          <SectionTitle>Favorecido</SectionTitle>
          <SectionItem>
            <span>NOME</span>
            <p>{beneficiaryName}</p>
          </SectionItem>
          <SectionItem>
            <span>{beneficiaryDocument?.length! > 11 ? 'CNPJ' : 'CPF'}</span>
            <p>
              {/* @ts-ignore */}
              {documentFormatted(beneficiaryDocument)}
            </p>
          </SectionItem>
          {counterpartyBank && (
            <SectionItem>
              <span>INSTITUIÇÃO</span>
              <p>{counterpartyBank}</p>
            </SectionItem>
          )}
          {city && (
            <SectionItem>
              <span>Cidade</span>
              <p>{city}</p>
            </SectionItem>
          )}
          {txId && (
            <SectionItem>
              <span>ID da Transação</span>
              <p>{txId}</p>
            </SectionItem>
          )}
          {/* // <SectionAccountinfo>
            //   <SectionItem>
            //     <span>{BeneficiaryAgencyOrIdentifier}</span>
            //     <span>AG</span>
            //   <p>{response?.proof?.beneficiary?.branch}</p>
            // </SectionItem>
            // <SectionItem>
            //   <span>CONTA</span>
            //   <p>{beneficiaryAccount}</p>
            //   </SectionItem>
            // </SectionAccountinfo> */}
        </Section>
        <ButtonWrapper>
          <Button
            handleFunction={printPDF}
            Icon={DownloadIcon}
            title="Baixar Comprovante"
          />
        </ButtonWrapper>
      </ModalContent>
    </>
  )
}
